import React from "react";
import NewHomepage from "./NewHomepage";

const Home = () => {
  return <NewHomepage />;
};

export default Home;
